// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"Sidebar_scroll-black__L5r89","sidebar":"Sidebar_sidebar__Fpa7b"};